<template>
    <div class="az-media-list-activity mg-t-30">
        <div class="media">
            <div class="media-icon mi">
                <i :class='[year.stage[0]==="N/A"?"el-icon-minus text-warning":"el-icon-check text-success"]'></i>
            </div>
            <div class="media-body" style='margin-left:0'>
                <div class="row row-sm" style="margin-left:5px">
                    <h6 class="tx-13" style="font-weight:400">{{year.stage[0]==="N/A"?'Fund Status is Not Available':year.stage[0]}}</h6><br>
                    <div style="padding-left:0">
                        <span class="badge badge-primary" style="color:white" v-show="date!==''">{{date}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="media" v-if="year.stage.length===2">
            <div class="media-icon mi tx-13">
                <i class="el-icon-check text-success"></i>
            </div>
            <div class="media-body" style="margin-left:0px">
                <h6 class="tx-13" style="font-weight:400">{{year.stage[1]}}</h6>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'stages',
    props:{
        year:{
           type: Object,
           required: true,
           default: ()=>{
               return null
           }
       },
       date:{
           type: String,
           required: true,
           default:()=>{
               return ''
           }
       }
    },
}
</script>
<style scoped>
.mi{
    /* background-color:#0f9747; */
    width: 18px;
    height: 18px;
    border-radius: 0%;
}
</style>